import React from "react";
import { Spin } from "antd";

interface LoadingOverlayProps {
  isLoading?: boolean;
  tip?: string;
  spinColor?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isLoading = false,
  tip = "Loading...",
  spinColor = "#f8f9fa",
}) => {
  // Configure dynamic styling if a custom color is provided
  const spinStyle = spinColor
    ? ({
        "--spin-color": spinColor,
      } as React.CSSProperties)
    : undefined;

  const spinClassName = `${spinColor ? "custom-color" : "white"}`;

  return (
    <div className={`loading-overlay ${isLoading ? "visible" : ""}`}>
      <div className="loading-overlay__backdrop" />
      <div className="loading-overlay__content" style={spinStyle}>
        <Spin size="large" className={spinClassName} />
        {tip && (
          <span
            className="loading-overlay__text"
            style={spinColor ? { color: spinColor } : undefined}
          >
            {tip}
          </span>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
